import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler'; 
import { DecimalPipe } from '@angular/common';
import { CreditBillAllotedAmtDetailsData, CreditBillAllotedAmtDetails } from '../../../@core/interfaces/pharmacy/CreditBillAllotedAmtDetails';
import { CreditPaymentDetailsData, CreditPaymentDetails } from '../../../@core/interfaces/pharmacy/CreditPaymentDetails';
import { CreditBillSettlementDetailsData, CreditBillSettlementDetails } from '../../../@core/interfaces/pharmacy/CreditBillSettlement';


export interface CreditBillReciptMstParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface CreditBillReciptMst { 

    id?: number;
    phBillReceiptDate :any;
    doneFrom :string;
    regId :string;
    phReceiptAmount :number;
    customerId :number;
    admissionId :number;
    paidAmount :number;
    createdBy:any;
    createdDate:any;
    branchId: string;
    tenantId: string;  
    settlementTable: CreditBillSettlementDetails[];
    allotedtable: CreditBillAllotedAmtDetails[];
    creditPayment:CreditPaymentDetails[];
    pharmacyId:number;
    parameters?: CreditBillReciptMstParameter[];
    links?: any;
    collectedFrom:string;
}


export abstract class CreditBillReciptMstData {
    abstract getall(url: string): Observable<CreditBillReciptMst[]>;
    abstract getById(url: string): Observable<any>;
    abstract create(url: string, data: CreditBillReciptMst): Observable<CreditBillReciptMst[]>;
    abstract searchList(url: string,data:any): Observable<any>;
}
